import { defineMessages } from 'react-intl';

export default defineMessages({
  ctsId: {
    id: 'sentinel.components.transferPanel.checkCtsId',
    defaultMessage: 'CTS ID',
  },
  payer: {
    id: 'sentinel.components.transferPanel.payer',
    defaultMessage: 'Payer',
  },
  beneficiary: {
    id: 'sentinel.components.transferPanel.beneficiary',
    defaultMessage: 'Beneficiary',
  },
  deliveryMethod: {
    id: 'sentinel.components.transferPanel.delivery',
    defaultMessage: 'Delivery Method',
  },
  memo: {
    id: 'sentinel.components.transferPanel.memo',
    defaultMessage: 'Memo',
  },
});



// WEBPACK FOOTER //
// ./src/components/transferPanelCheckDetails/messages.js